// @flow

import {
	BIRTH_CERTIFICATE_RF,
	MILITARY_PASSPORT,
	PASSPORT_RF,
	SEAMAN_PASSPORT,
	TRAVEL_PASSPORT,
	RESIDENCE_PERMIT,
	FOREIGN_PASSPORT,
} from 'known-rest-identity-docs';

export type IDocumentTypeInputmaskExtend = {
	inputmask: () => Object,
};

const documentTypeInputMaskExtend = {
	anonymous: target => {
		target.inputmask = () => {
			if (target() === PASSPORT_RF){
				return '9999 999999';
			} else if (target() === MILITARY_PASSPORT){
				// TODO: this should be defined closer to `vb.militaryPassport`
				return 'AA 9{6,7}';
			} else if (target() === SEAMAN_PASSPORT){
				return {
					mask: 'RR 9{6,7}',
					casing: "upper",
					greedy: false,
					definitions: {
						'R': {
							validator: '[а-яёА-ЯЁABEKMHOPCTYXabekmhopctyx03]',
							cardinality: 1,
						},
					},
				};
			} else if (target() === TRAVEL_PASSPORT){
				return '99 9999999';
			} else if (target() === RESIDENCE_PERMIT) {
				return {
					mask: 'RR[R]{1,4} 99999[9][9]',
					casing: "upper",
					greedy: false,
					definitions: {
						'R': {
							validator: '[а-яёА-ЯЁIi0-9-]',
							cardinality: 1,
						},
					},
				};
			} else if (target() === BIRTH_CERTIFICATE_RF){
				return {
					mask: 'RRRR[R]{1,5} 999999',
					casing: "upper",
					greedy: false,
					definitions: {
						'R': {
							validator: '[а-яёА-ЯЁABEKMHOPCTYXIVabekmhopctyxiv013-]',
							cardinality: 1,
						},
					},
				};
			} else if (target() === FOREIGN_PASSPORT) {
				return {
					mask: 'A{*}',
					placeholder: '',
					definitions: {
						'A': {
							validator: '[ 0-9a-zA-Zа-яёА-ЯЁ-]',
							cardinality: 1,
						},
					},
				};
			}
	
			return {
				mask: 'A{*}',
				placeholder: '',
				definitions: {
					'A': {
						validator: '[ 0-9a-zA-Zа-яёА-ЯЁ]',
						cardinality: 1,
					},
				},
			};
		};
	}
};

export { documentTypeInputMaskExtend };
